/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { VideoModal } from '../../components/VideoModal';
import VideoLibraryOutlinedIcon from '@material-ui/icons/VideoLibraryOutlined';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvBarDatasetStyle, rvChartAnimation, rvValueAxisStyle, rvCategoryAxisStyle, rvTooltipStyle, rvLegendLabels, isChartDataEmpty } from '../chartTheme';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartStatTiles } from '../ChartStatTiles';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
            '&:hover': {
                '& .scroll': {
                    display: 'flex !important',
                    '& .Mui-disabled': {
                        '& .MuiSvgIcon-root': {
                            color: 'inherit !important',
                        },
                    },
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        footerDescription: {
            fontSize: '1rem',
            textAlign: 'center',
        },
        learnIcon: {
            color: 'rgb(0, 120, 212)'
        },
        scrollUp: {
            display: 'none',
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            display: 'none',
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
    }),
);

enum DateRangeSelectionEnum {
    TODAY = 0,
    YESTERDAY,
    THIS_WEEK,
    LAST_WEEK,
    THIS_MONTH,
    LAST_MONTH,
}

interface HoursRecordedByStaffMemberChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: DateRangeSelectionEnum;
    infoUrl: string | null;
}

interface ChartState extends HoursRecordedSummary {
    options: DateRangeSelectionEnum;
    hoursRecorded: HoursRecorded[];
    symbol: string;
}

export const HoursRecordedByStaffMemberChart: React.FC<HoursRecordedByStaffMemberChartProps> = (props) => {
    const classes = useStyles();

    const chartName = 'Total Hours Recorded';

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false);

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0,
    })[1];

    const [state, setState] = useState<ChartState>({
        options: props.selectedOption === undefined ? DateRangeSelectionEnum.THIS_WEEK : props.selectedOption,
        totalFees: 0,
        hoursRecorded: [],
        symbol: '$',
        totalBillableHours: 0,
        totalNonBillableHours: 0,
        totalHours: 0,
    });

    React.useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };
    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    // tslint:disable-next-line:no-any
    const hoursRecordedByStaffMemberQuery = useQuery<HoursRecordedStaffMemberData>(HOURS_RECORDED_BY_STAFF_MEMBER_QUERY, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        // tslint:disable-next-line: max-line-length
        if (
            hoursRecordedByStaffMemberQuery.data &&
            hoursRecordedByStaffMemberQuery.data.statistics &&
            hoursRecordedByStaffMemberQuery.data.statistics.time &&
            hoursRecordedByStaffMemberQuery.data.statistics.time.hoursRecordedByStaffMembers &&
            !hoursRecordedByStaffMemberQuery.loading &&
            !hoursRecordedByStaffMemberQuery.error
        ) {
            const { today, yesterday, thisWeek, lastWeek, thisMonth, lastMonth } = hoursRecordedByStaffMemberQuery.data.statistics.time.hoursRecordedByStaffMembers;

            let totalBillableHours: number = 0;
            let totalNonBillableHours: number = 0;
            let totalHours: number = 0;
            let totalFees: number = 0;
            
            let hoursRecorded: HoursRecorded[] = [];

            if (state.options === DateRangeSelectionEnum.TODAY) {
                hoursRecorded = today.hoursRecorded;
                totalFees = today.summary.totalFees;
                totalBillableHours = today.summary.totalBillableHours;
                totalNonBillableHours = today.summary.totalNonBillableHours;
                totalHours = today.summary.totalHours;
            } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                hoursRecorded = yesterday.hoursRecorded;
                totalFees = yesterday.summary.totalFees;
                totalBillableHours = yesterday.summary.totalBillableHours;
                totalNonBillableHours = yesterday.summary.totalNonBillableHours;
                totalHours = yesterday.summary.totalHours;
            } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                hoursRecorded = thisWeek.hoursRecorded;
                totalFees = thisWeek.summary.totalFees;
                totalBillableHours = thisWeek.summary.totalBillableHours;
                totalNonBillableHours = thisWeek.summary.totalNonBillableHours;
                totalHours = thisWeek.summary.totalHours;
            } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                hoursRecorded = lastWeek.hoursRecorded;
                totalFees = lastWeek.summary.totalFees;
                totalBillableHours = lastWeek.summary.totalBillableHours;
                totalNonBillableHours = lastWeek.summary.totalNonBillableHours;
                totalHours = lastWeek.summary.totalHours;
            } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                hoursRecorded = thisMonth.hoursRecorded;
                totalFees = thisMonth.summary.totalFees;
                totalBillableHours = thisMonth.summary.totalBillableHours;
                totalNonBillableHours = thisMonth.summary.totalNonBillableHours;
                totalHours = thisMonth.summary.totalHours;
            } else {
                hoursRecorded = lastMonth.hoursRecorded;
                totalFees = lastMonth.summary.totalFees;
                totalBillableHours = lastMonth.summary.totalBillableHours;
                totalNonBillableHours = lastMonth.summary.totalNonBillableHours;
                totalHours = lastMonth.summary.totalHours;
            }
            setState((prevState) => {
                return {
                    ...prevState,
                    hoursRecorded,
                    totalFees,
                    totalBillableHours,
                    totalNonBillableHours,
                    totalHours,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [state.options, hoursRecordedByStaffMemberQuery.loading, hoursRecordedByStaffMemberQuery.error, hoursRecordedByStaffMemberQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart(`isHoursRecordedByStaffMembersChartOpen`);
        }
    };

    const GetDateRangeSelectiondLabel = (dateRangeEnum: DateRangeSelectionEnum) => {
        switch (dateRangeEnum) {
            case DateRangeSelectionEnum.TODAY:
                return 'Today';
            case DateRangeSelectionEnum.YESTERDAY:
                return 'Yesterday';
            case DateRangeSelectionEnum.THIS_WEEK:
                return 'This Week';
            case DateRangeSelectionEnum.LAST_WEEK:
                return 'Last Week';
            case DateRangeSelectionEnum.THIS_MONTH:
                return 'This Month';
            case DateRangeSelectionEnum.LAST_MONTH:
                return 'Last Month';
            default:
                return '';
        }
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            if (state.options === DateRangeSelectionEnum.TODAY) {
                searchCriterias.push({ property: 'ThisDay', operator: '', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                searchCriterias.push({ property: 'ThisDay', operator: '', comparison: 'prev' });
            } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                searchCriterias.push({ property: 'ThisWeek', operator: '', comparison: 'curr' });
            } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                searchCriterias.push({ property: 'ThisWeek', operator: '', comparison: 'prev' });
            } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                searchCriterias.push({ property: 'ThisMonth', operator: '', comparison: 'curr' });
            } else {
                searchCriterias.push({ property: 'ThisMonth', operator: '', comparison: 'prev' });
            }
            props.getSelectedItem(searchCriterias, true, `Hours Recorded ${GetDateRangeSelectiondLabel(state.options)}`, DrillDownType.timesheetSummary, 'Activity');
        }
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                options: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1;
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };

    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.format);

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        } else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        }
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {
        const labels = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.format);
        // up
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    const onZoom = (context: { chart: Chart }) => {
        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.options);
        }
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    const onToggleVideo = () => {
        setIsVideoModalOpen(!isVideoModalOpen);
    };

    // tslint:disable-next-line: no-any
    const onDownload =
        (name: string, extension: string = 'jpg') =>
        // tslint:disable-next-line: no-any
        (image: any) => {
            const a = document.createElement('a');
            a.href = image;
            a.download = createFileName(extension, name);
            a.click();
        };

    // tslint:disable-next-line: no-any
    const onDownloadScreenshot = (event: any) => {
        event.preventDefault();
        event.stopPropagation();
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload(`Hours Recorded`));
            // tslint:disable-next-line: align
        }, 500);
    };

    // tslint:disable-next-line: no-any
    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
            }
            });
        }

        setIsBlobGenerating(false);
    };

    const chartControlComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <div
                        className={`${classes.helpIcon} rv-chart-help`} 
                    >
                        <ChartInfo 
                            description={props.description}
                            fontSize={props.showAllRecords ? 'large' : 'medium'}
                            // className={classes.helpIcon}
                        />
                        {props.infoUrl && (
                            <MTooltip title="Learn more">
                                <IconButton className={classes.learnIcon} aria-label="maximize" onClick={onToggleVideo} size={props.showAllRecords ? 'medium' : 'small'}>
                                    <VideoLibraryOutlinedIcon />
                                </IconButton>
                            </MTooltip>
                        )}
                    </div>
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    if (hoursRecordedByStaffMemberQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControlComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    const chartLabels = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.format);

    const chartDataBillable = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.billableHours);
    
    const chartDataNonBillable = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.nonBillableHours);

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(chartDataBillable, chartDataNonBillable) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
                {isVideoModalOpen && props.infoUrl && (
                    <VideoModal 
                        open={isVideoModalOpen}
                        onClose={onToggleVideo}
                        url={props.infoUrl}
                    />
                )}
                {chartControlComponent()}
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<AccessTimeOutlinedIcon />} title={chartName} subtitle={GetDateRangeSelectiondLabel(state.options)} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.totalHours} format={(amount) => state.totalHours > 0 ? `${formatNumber(amount, 1)}` : 0} />
                        <span className="rv-unit">hrs</span>
                    </div>
                    <ChartStatTiles
                        tiles={[
                            { label: 'Billable', value: state.totalBillableHours > 0 ? formatNumber(state.totalBillableHours, 1) : 0, color: RV_CHART_COLORS.primary },
                            { label: 'Non-billable', value: state.totalNonBillableHours > 0 ? formatNumber(state.totalNonBillableHours, 1) : 0, color: RV_CHART_COLORS.primarySoft },
                            { label: 'Total fees', value: `${state.symbol}${formatNumber(state.totalFees)}`, color: RV_CHART_COLORS.green },
                        ]}
                    />
                </div>
                <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                    {props.showAllRecords && (
                        <>
                            <div className={`${classes.scrollUp} scroll`}>
                                <IconButton size="medium" onClick={onScollBar('up')} ref={scrollUpAndPrevRef}>
                                    <KeyboardArrowUpIcon color="primary" fontSize="large" />
                                </IconButton>
                            </div>
                            <div className={`${classes.scrollDown} scroll`}>
                                <IconButton size="medium" onClick={onScollBar('down')} ref={scrollDownAndNextRef}>
                                    <KeyboardArrowDownIcon color="primary" fontSize="large" />
                                </IconButton>
                            </div>
                        </>
                    )}
                    <Bar
                        ref={chartRef}
                        onContextMenu={onContextMenu}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {
                                const _index = getElementAtEvent(chartRef.current, event)[0].index;

                                const item = state.hoursRecorded.map((hourRecorded: HoursRecorded) => hourRecorded.format)[_index];

                                const grouping = state.hoursRecorded[_index].grouping;

                                const searchCriterias = new Array<SearchCriteria>();

                                if (state.options === DateRangeSelectionEnum.TODAY) {
                                    searchCriterias.push(
                                        { property: 'ThisDay', operator: '', comparison: 'curr' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.YESTERDAY) {
                                    searchCriterias.push(
                                        { property: 'ThisDay', operator: '', comparison: 'prev' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                                    searchCriterias.push(
                                        { property: 'ThisWeek', operator: '', comparison: 'curr' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.LAST_WEEK) {
                                    searchCriterias.push(
                                        { property: 'ThisWeek', operator: '', comparison: 'prev' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                } else if (state.options === DateRangeSelectionEnum.THIS_MONTH) {
                                    searchCriterias.push(
                                        { property: 'ThisMonth', operator: '', comparison: 'curr' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                } else {
                                    searchCriterias.push(
                                        { property: 'ThisMonth', operator: '', comparison: 'prev' },
                                        { property: 'StaffTime', operator: '', comparison: grouping },
                                    );
                                }
                                props.getSelectedItem(
                                    searchCriterias,
                                    true,
                                    `Hours Recorded by ${item} ${GetDateRangeSelectiondLabel(state.options)}`,
                                    DrillDownType.timesheetSummary,
                                    'Activity',
                                );
                            }
                        }}
                        data={{
                            labels: getLabels(chartLabels),
                            datasets: [
                                {
                                    label: 'Billable Hours',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primary, true),
                                    data: chartDataBillable,
                                },
                                {
                                    label: 'Non-Billable Hours',
                                    ...rvBarDatasetStyle(RV_CHART_COLORS.primarySoft, true),
                                    data: chartDataNonBillable,
                                },
                            ],
                        }}
                        options={{
                            onHover: onHover,
                            indexAxis: 'y' as const,
                            animation: rvChartAnimation(),
                            elements: { bar: { borderWidth: 0 } },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: rvValueAxisStyle.grid,
                                    // beginAtZero: true,
                                    suggestedMax: getSuggestedMaxTick([...chartDataBillable, ...chartDataNonBillable]),
                                    beginAtZero: true,
                                    ticks: {
                                        ...rvValueAxisStyle.ticks,
                                        maxTicksLimit: getMaxTickLimit([...chartDataBillable, ...chartDataNonBillable]),
                                        autoSkip: false,
                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                            return `${formatNumber(tickValue)}`;
                                        },
                                    },
                                    stacked: true,
                                },
                                y: {
                                    grid: rvCategoryAxisStyle.grid,
                                    min: 0,
                                    max: props.showAllRecords ? 29 : 9,
                                    ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                        autoSkip: false,
                                    },
                                    stacked: true,
                                },
                            },
                            plugins: {
                                legend: {
                                    position: 'bottom' as const,
                                    display: true,
                                    labels: rvLegendLabels,
                                },
                                title: {
                                    display: false,
                                    text: ``,
                                },
                                zoom: {
                                    pan: {
                                        enabled: props.showAllRecords,
                                        onPan: onPan,
                                    },
                                    zoom: {
                                        wheel: {
                                            enabled: props.showAllRecords,
                                        },
                                        onZoom: onZoom,
                                    },
                                    // limits: {
                                    //   y: { min: 0, max: 9 },
                                    // },
                                },
                                tooltip: {
                                    ...rvTooltipStyle,
                                    callbacks: {
                                        // tslint:disable-next-line: no-any
                                        label: function (context: any) {
                                            const {
                                                dataIndex,
                                                //   label,
                                                formattedValue,
                                                dataset,
                                            } = context;

                                            var currentValue = convertStringNumberToNumber(formattedValue);

                                            var tooltips = [`${dataset.label}: ${currentValue}`];

                                            if (state.options === DateRangeSelectionEnum.THIS_WEEK) {
                                                tooltips.push(`Sunday: ${formatNumber(state.hoursRecorded[dataIndex].sunday, 1)}`);
                                                tooltips.push(`Monday: ${formatNumber(state.hoursRecorded[dataIndex].monday, 1)}`);
                                                tooltips.push(`Tuesday: ${formatNumber(state.hoursRecorded[dataIndex].tuesday, 1)}`);
                                                tooltips.push(`Wednesday: ${formatNumber(state.hoursRecorded[dataIndex].wednesday, 1)}`);
                                                tooltips.push(`Thursday: ${formatNumber(state.hoursRecorded[dataIndex].thursday, 1)}`);
                                                tooltips.push(`Friday: ${formatNumber(state.hoursRecorded[dataIndex].friday, 1)}`);
                                                tooltips.push(`Saturday: ${formatNumber(state.hoursRecorded[dataIndex].saturday, 1)}`);
                                            }

                                            return tooltips;
                                        },
                                        // tslint:disable-next-line: no-any no-shadowed-variable
                                        afterLabel: function (context: any) {
                                            const { dataIndex } = context;

                                            const feeAmount = state.hoursRecorded[dataIndex].valueAmount;
                                            const hours = state.hoursRecorded[dataIndex].totalHours;

                                            return [
                                                `Total Hours: ${formatNumber(hours, 1)}`,
                                                `Fee Amount: ${state.symbol}${formatNumber(feeAmount, 2)}`
                                            ];
                                        },
                                    },
                                },
                            },
                        }}
                    />
                    {isChartDataEmpty(chartDataBillable, chartDataNonBillable) && (
                        <ChartEmptyState title="No hours recorded" hint={`Nothing for ${GetDateRangeSelectiondLabel(state.options)}. Try another period below.`} />
                    )}
                </div>
                <FormControl component="div">
                    <RadioGroup name="last" value={state.options} onChange={onChangeRadio} className={classes.radioGroup}>
                        <FormControlLabel value={DateRangeSelectionEnum.TODAY} control={<Radio color="primary" />} label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.TODAY)} />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.YESTERDAY}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.YESTERDAY)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.THIS_WEEK}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.THIS_WEEK)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.LAST_WEEK}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_WEEK)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.THIS_MONTH}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.THIS_MONTH)}
                        />
                        <FormControlLabel
                            value={DateRangeSelectionEnum.LAST_MONTH}
                            control={<Radio color="primary" />}
                            label={GetDateRangeSelectiondLabel(DateRangeSelectionEnum.LAST_MONTH)}
                        />
                    </RadioGroup>
                </FormControl>
                {/* <span className={classes.span}>{formatNumber(state.openEnquiryCount)} open enquiries have no Fee Estimate</span> */}
                {/* <span className={classes.span}>Drill down to timekeeper details</span>     
                <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
            </div>
        </>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export type HoursRecordedStaffMemberData = {
    statistics: Statistics;
};

export type Statistics = {
    time: Time;
};

export type Time = {
    hoursRecordedByStaffMembers: HoursRecordedByStaffMembers;
};

export type HoursRecordedByStaffMembers = {
    today:     LastMonth;
    yesterday: LastMonth;
    thisWeek:  LastMonth;
    lastWeek:  LastMonth;
    thisMonth: LastMonth;
    lastMonth: LastMonth;
};

export type LastMonth = {
    hoursRecorded: HoursRecorded[];
    summary:       HoursRecordedSummary;
};

export type HoursRecorded = {
    format:           string;
    grouping:         string;
    billableHours:    number;
    nonBillableHours: number;
    totalHours:       number;
    valueAmount:      number;
    sunday:           number;
    monday:           number;
    tuesday:          number;
    wednesday:        number;
    thursday:         number;
    friday:           number;
    saturday:         number;
};

export type HoursRecordedSummary = {
    totalBillableHours:    number;
    totalNonBillableHours: number;
    totalHours:            number;
    totalFees:             number;
};

const HOURS_RECORDED_BY_STAFF_MEMBER_QUERY = gql`
    fragment FragmentHoursRecordedByStaffMembersGrouping on HoursRecordedByStaffMembersGrouping {
        hoursRecorded {
            format
            grouping
            billableHours
            nonBillableHours
            totalHours
            valueAmount
            sunday
            monday
            tuesday
            wednesday
            thursday
            friday
            saturday
        }
        summary {
            totalBillableHours
            totalNonBillableHours
            totalHours
            totalFees
        }
    }
    query HoursRecordedByStaffMembers($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
        statistics {
            time {
                hoursRecordedByStaffMembers(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords) {
                    today {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                    yesterday {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                    thisWeek {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                    lastWeek {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                    thisMonth {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                    lastMonth {
                        ...FragmentHoursRecordedByStaffMembersGrouping
                    }
                }
            }
        }
    }
`;
